/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-prev2': {
    width: 15,
    height: 14,
    viewBox: '0 0 15 14',
    data: '<path pid="0" d="M6.417 1L1 7l5.417 6M1 7h13" _stroke="#C09C5E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
